<div
  *transloco="let t"
  class="flex flex-col bg-white border border-surface-subtle rounded-lg overflow-hidden max-h-60 lg:max-h-[calc((100dvh-2.5rem)/3)]"
>
  <div class="bg-surface-card border-b border-surface-subtle flex items-center gap-2 px-4 py-3 shrink-0">
    <span class="text-xs font-semibold text-primary uppercase tracking-widest">
      {{ t('ORDER-DETAILS.ATTACHMENTS') }}
    </span>
    <div class="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/10">
      <span class="text-[0.625rem] font-bold text-primary">
        {{ documents().length | translocoDecimal }}
      </span>
    </div>
  </div>
  <div class="flex-1 min-h-0" dssLibsUiAutoHideScrollbar>
    @for (doc of documents(); track doc.id) {
    <div class="flex items-center gap-1.5 ps-4 py-2.5 pe-2 border-surface-subtle" [class.border-b]="!$last">
      <div class="w-8 h-8 flex items-center justify-center shrink-0 bg-primary-tint-soft rounded-md p-0.5">
        <mat-icon class="text-primary! size-5!" svgIcon="file-bold"></mat-icon>
      </div>
      <div class="flex flex-col gap-1 flex-1 min-w-0">
        <span
          class="text-sm font-medium text-ink truncate"
          [matTooltip]="doc.fileName"
          matTooltipPosition="below"
          matTooltipClass="tooltip-white"
          dssLibsUiTooltipIfTruncated
        >
          {{ doc.fileName }}
        </span>
        <span
          class="text-xs text-ink-muted line-clamp-2"
          matTooltip="{{ doc.fileSize | fileSize }} · {{ t('ORDER-DETAILS.UPLOADED-BY') }} {{ userName() || '—' }}"
          matTooltipPosition="below"
          matTooltipClass="tooltip-white"
          dssLibsUiTooltipIfTruncated
        >
          {{ doc.fileSize | fileSize }}
          &middot; {{ t('ORDER-DETAILS.UPLOADED-BY') }} {{ userName() || '—' }}
        </span>
      </div>
      @if (doc.fileLink) {
      <a
        [attr.href]="doc.fileLink"
        [attr.download]="doc.fileName"
        target="_blank"
        rel="noopener"
        class="p-2 flex items-center justify-center rounded-md text-ink-hint hover:bg-surface-subtle transition-colors"
      >
        <mat-icon class="size-4! text-ink-subtle!" svgIcon="download-minimal-outline"></mat-icon>
      </a>
      }
    </div>
    }
  </div>
</div>
